<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent()"
  [title]="titlePage"
  start="{{startStage}}"
  end="{{endStage}}"
></app-ion-common-header>

<ion-content
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <app-ion-common-label
    class="document-type-label1"
    labelStyle="display-rg"
    labelDescription="Possui complemento?"
  >
  </app-ion-common-label>

  <div class="conent-center conent-center--mrt-lg">
    <form [formGroup]="addressAdjuntForm">
      <app-ion-common-input
        [fieldValue]="nameAdjunt"
        [placeholder]="placeholder"
        [error]="error"
        [id]="idComponentAdjunt"
        [textError]="textError"
        maxLength="20"
        (textChange)="nameAdjunt=$event; errorMessage();"
        type="text"
        [idLabel]="idLabel"
        [label]="label"
        [replaceStrTo]="'documentWithSpace'"
        name="adjuntAddress"
        formControlName="adjuntAddress"
        [disabled]="!this.edit"
        ngDefaultControl
      >
      </app-ion-common-input>
    </form>
  </div>

  <app-ion-common-button
    class="hidden"
    [ngClass]="{'hidden': !buttonEnable}"
    [attr.aria-hidden]="!buttonEnable"
    label="Continuar"
    (clickButton)="clickNext();"
  ></app-ion-common-button>
</ion-content>
